<template>
  <div id="xy_fp" class="setPad">
    <topNav :title="title"></topNav>

    <div class="top_main">
      <div class="allA"></div>
      <div class="main relativeItem">
        <ul class="pai_box relativeItem" :style="{ height: paiHgt }">
          <li class="lis absoluteItem" v-for="(n, i) in giftList" :key="i">
            <img
              class="opcityNone imgBlock noevents-img"
              src="../../assets/xyuan/21(27).png"
            />
            <div class="front_div absoluteItem" @click="clickPaiFun(i)">
              <img
                class="imgBlock noevents-img"
                src="../../assets/xyuan/21(27).png"
              />
            </div>
            <div class="back_div absoluteItem">
              <img
                class="imgBlock noevents-img"
                src="../../assets/xyuan/21(25).png"
              />
              <div class="gift_con absoluteItem centerX">
                <div class="g_img absoluteItem centerImg">
                  <img
                    :id="'gimg' + i"
                    class="imgBlock noevents-img"
                    :src="n.gift_image"
                  />
                </div>
              </div>
              <div :id="'gname' + i" class="g_name absoluteItem centerX">
                {{ n.gift_name }}
              </div>
            </div>
          </li>
        </ul>

        <!-- 底部按钮区域 -->
        <div class="botm_box" v-if="showBotm">
          <p class="cord_con">
            <i @click="clickCordFun"> 中奖记录 </i>
          </p>
          <div class="botm_div relativeItem" @click="seleAll">
            <img
              class="imgBlock noevents-img"
              src="../../assets/xyuan/21(31).png"
            />
            <div class="ab_con absoluteItem centerX flex-box">
              <i>抽奖次数</i>
              <i>&nbsp;{{ allNum }}&nbsp;</i>
              <i>次</i>
            </div>
          </div>
        </div>
      </div>

      <!-- 确定扣除次数的弹窗 -->
      <div class="tc" v-show="showConfirmTc">
        <div class="kou_box absoluteItem centerImg">
          <img
            class="imgBlock noevents-img"
            src="../../assets/xyuan/tcall.png"
          />
          <div class="kou_main absoluteItem centerX centerY">
            <div class="text_con">
              确认当前<i>&nbsp;{{ canNum }}&nbsp;</i>次机会全部使用?
            </div>
            <div class="b_main flex-box">
              <div @click="showConfirmTc = false">
                <img
                  class="imgBlock noevents-img"
                  src="../../assets/xyuan/quxiao.png"
                />
              </div>
              <div @click="confirmTakeFun">
                <img
                  class="imgBlock noevents-img"
                  src="../../assets/xyuan/queren.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 记录的弹窗 -->
    <div class="tc tc_high" v-show="showCordTc">
      <div class="tc_main absoluteItem centerImg">
        <div class="close_div absoluteItem" @click="showCordTc = false">
          <img
            class="imgBlock noevents-img"
            src="../../assets/xyuan/21(22).png"
            alt=""
          />
        </div>
        <div class="cord_jl relativeItem">
          <img
            class="imgBlock noevents-img"
            src="../../assets/xyuan/21(30).png"
          />
          <div id="ulboxs" class="gift_main absoluteItem centerX">
            <ul class="gift_box" v-if="cordList.length > 0">
              <li class="cor_lis flex-box" v-for="(n, i) in cordList" :key="i">
                <div class="gimg_box relativeItem">
                  <img
                    class="absoluteItem centerImg imgBlock noevents-img"
                    :src="n.gift_image"
                  />
                </div>
                <div class="r_box flex-box">
                  <p>{{ n.gift_name }}</p>
                  <p>{{ n.create_time }}</p>
                </div>
              </li>
            </ul>
            <div class="nomore" v-if="nomore">--没有更多了--</div>
          </div>

          <!-- 没有中奖记录的显示 -->
          <div class="kongbox absoluteItem centerImg" v-show="isCordBlank">
            <img
              class="imgBlock noevents-img"
              src="../../assets/xyuan/blankimg.png"
            />
            <p class="text_no">- 暂无数据 -</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>










<script>
import topNav from "./topNav";

export default {
  name: "xy_fp",
  components: {
    topNav,
  },
  data() {
    return {
      showCordTc: false, //中奖记录的弹窗
      isCordBlank: false, //中奖记录为空的判断
      allNum: 0, //抽奖的总次数
      canNum: 0, //可以抽奖的次数
      clickNum: 0, // 当前点击的次数
      width: 31,
      paiHgt: 0, //牌外部盒子的高度
      isCanFan: false,
      showConfirmTc: false, //扣除次数的弹窗
      giftList: [], // 所有礼物的数组
      cordList: [], //中奖记录
      channel: "", //每次翻牌抽奖时携带的参数
      page: 1, //中奖记录的页码 默认1
      showBotm: false,
      nomore: false,
      list_more: true,
      title: "新语新愿",
      // idName: "#xy_fp",
      canClick: false,
    };
  },
  mounted() {
    this.$tool.setTitle("新语新愿抽奖");
    this.$appAc.app_refreshUsable(0); //阻止安卓的刷新
    this.getAllNum();
    this.setTopPad();
    setTimeout(() => {
      this.startGame();
    }, 1500);
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },

    // 获取牌盒子的高度
    getHeight() {
      let item = document.querySelector(".lis");
      this.paiHgt = item.offsetHeight * 3 + 50 + "px";
      this.channel =
        this.$tool.getTimeC() + "" + this.$tool.randomWord(true, 5, 5);
      this.showBotm = true;
      setInterval(() => {
        //判断当前时间是不是23点59分59秒 是的话就强制刷新页面
        let timeNow = this.formatTimer(this.$tool.getTimeC());
        if (timeNow == "00:00:00") {
          // 刷新当前页面
          window.location.reload();
        }
      }, 1000);
    },

    formatTimer(timestamp) {
      let date = new Date(timestamp * 1000); //根据时间戳生成的时间对象
      let h = date.getHours();
      let min = date.getMinutes();
      let se = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      min = min < 10 ? "0" + min : min;
      se = se < 10 ? "0" + se : se;
      let dateText = h + ":" + min + ":" + se;
      return dateText;
    },

    // 点击中奖记录
    clickCordFun() {
      if (!this.canClick) {
        return;
      }
      this.showCordTc = true;
      // 请求中奖记录的接口
      let _this = this,
        data = {
          page: this.page,
          pagesize: 20,
        };
      this.$jsonp(this.$apis("xy_DrawCord"), data, (res) => {
        let ls = res.data.data;
        if (ls.length > 0) {
          // 有数据
          if (_this.page == 1) {
            _this.cordList = ls;
            setTimeout(() => {
              _this.scroll_event();
            }, 500);
          } else {
            _this.cordList = _this.cordList.concat(ls);
          }
        } else {
          _this.list_more = false;
          if (data.page == 1) {
            _this.isCordBlank = true;
            _this.nomore = false;
          } else {
            _this.nomore = true;
          }
        }
      });
    },

    // 滚动加载更多
    scroll_event() {
      let item = document.querySelector("#ulboxs");
      let _this = this;
      let utop,
        sHeight,
        cheight = null;
      item.addEventListener("scroll", (e) => {
        (utop = e.target.scrollTop),
          (sHeight = e.target.scrollHeight),
          (cheight = e.target.clientHeight);
        if (sHeight - (utop + cheight) <= 50 && _this.list_more) {
          _this.page++;
          _this.clickCordFun();
        }
      });
    },

    // 每一个牌的点击
    clickPaiFun(idx) {
      if (this.allNum == 0) {
        this.$tool.tip("您还没有抽奖次数~", "50%");
        return;
      }
      if (!this.isCanFan) {
        return;
      }

      let _this = this;
      let data = {
        channel: _this.channel,
        draw_all: 0, // 0挨个点  1全翻
      };
      // 次数为0就提示没有抽奖次数
      if (this.allNum < 0) {
        this.allNum = 0;
        this.$tool.tip("您没有抽奖次数了~", "50%");
        return;
      } else {
        // 请求后台拿到获取的礼物奖励
        this.$jsonp(this.$apis("xy_DrawGift"), data, (res) => {
          if (res.data.data.status == 1) {
            let giftObj = res.data.data.list[0];
            this.allNum--;
            let ele = document.querySelectorAll(".lis");
            ele[idx].classList.add("aniSele");
            this.clickNum += 1;
            let gname = document.getElementById("gname" + idx);
            let gimg = document.getElementById("gimg" + idx);
            gname.innerText = giftObj.gift_name;
            gimg.src = giftObj.gift_image;
          }
        });
      }
    },

    // 1.将所有的牌反过来 2.定位到第五张的位置   3.打乱再分发到每个位置
    startGame() {
      this.isCanFan = true;
      let ele = document.querySelectorAll(".lis");
      // 1.将所有的牌反过来
      for (let i = 0; i < ele.length; i++) {
        ele[i].classList.add("aniDiv");
      }
      setTimeout(() => {
        document.querySelector(".pai_box").classList.add("anima_box");
        document.querySelector(".pai_box").classList.add("ctr_box");
      }, 1000);
      // 3.打乱再分发到每个位置 发牌前将礼物数组打乱排放
      setTimeout(() => {
        this.faPia();
      }, 1700);
    },

    // 发牌
    faPia() {
      document.querySelector(".pai_box").classList.remove("ctr_box");
      this.randomArr(this.giftList);
      this.$forceUpdate();
      this.canClick = true;
    },

    // 礼物数组顺序打乱
    randomArr(arr) {
      let length = arr.length;
      //while执行至条件不成立则跳出循环
      while (length > 1) {
        // --length 先自减再执行表达式
        // length-- 先执行表达式再自减
        //length 先执行random和floor得到index后再自减
        let index = Math.floor(Math.random() * length--);
        //es6的解构赋值，等号的左右两边模式相同，就会将右边的值赋给左边的变量
        [arr[length], arr[index]] = [arr[index], arr[length]];
      }
      return arr;
    },

    // 全翻的操作
    seleAll() {
      if (!this.isCanFan) {
        return;
      }

      if (this.clickNum >= 9 || this.allNum == 0) {
        this.$tool.tip("当前奖品已经抽完了哦~", "50%");
        return;
      }
      if (this.allNum >= 9) {
        if (this.clickNum == 0) {
          this.canNum = 9;
        } else {
          this.canNum = 9 - this.clickNum;
        }
      } else {
        //所有的次数小于9
        if (this.clickNum == 0) {
          this.canNum = this.allNum;
        } else {
          //判断没翻的和剩余次数
          if (9 - this.clickNum <= this.allNum) {
            this.canNum = 9 - this.clickNum;
          } else {
            this.canNum = this.allNum;
          }
        }
      }
      this.showConfirmTc = true;
    },

    // 全翻抽奖弹窗的确认点击事件
    confirmTakeFun() {
      // draw_all: 1;  全抽点击传参数1   一个个点传0   0挨个点  1全翻
      this.showConfirmTc = false;
      let ele = document.querySelectorAll(".lis");
      // 没有单个点的 clickNum是0 全翻1-9
      if (this.canNum == 9) {
        // 请求全翻的接口
        let _this = this;
        let data = {
          channel: _this.channel,
          draw_all: 1, // 0挨个点  1全翻
        };
        // 请求后台拿到获取的礼物奖励
        this.$jsonp(this.$apis("xy_DrawGift"), data, (res) => {
          if (res.data.data.list.length != 0) {
            for (let i = 0; i < ele.length - this.clickNum; i++) {
              ele[i].classList.add("aniSele");
            }
            _this.giftList = _this.randomArr(res.data.data.list);
            _this.allNum -= 9;
            _this.$forceUpdate();
          }
        });
      } else if (this.clickNum != 0) {
        //已经单点n个后再点全翻的操作
        // console.log(ele); // 所有的翻牌数组  9个
        // console.log(this.canNum); // 可以用翻的次数
        let newArr = []; // 还没有翻过来的数组
        ele.forEach((item) => {
          if (item.className.indexOf("aniSele") == -1) {
            //不包含的
            newArr.push(item);
          }
        });
        if (this.allNum >= this.canNum) {
          let _this = this;
          let data = {
            channel: _this.channel,
            draw_all: 1, // 0挨个点  1全翻
          };
          // 请求后台拿到获取的礼物奖励
          this.$jsonp(this.$apis("xy_DrawGift"), data, (res) => {
            if (res.data.data.list.length != 0) {
              let giftArr = res.data.data.list; //抽奖对应的奖品返回
              for (let i = 0; i < newArr.length; i++) {
                newArr[i].classList.add("aniSele");
                newArr[i].children[2].children[1].children[0].children[0].src =
                  giftArr[i].gift_image;
                newArr[i].children[2].children[1].children[1].innerText =
                  giftArr[i].gift_name;
              }
              _this.allNum -= _this.canNum;
            }
          });
        } else {
          alert("总数小于可翻次数");
          console.log(this.allNum);
          console.log(this.canNum);
          console.log("总数小于可翻次数");
          // 总数小于剩余没有反过来的个数  就从没有翻的数组里 取allNum个 请求接口 把请求的数据塞到对应的数组内部
          console.log(newArr);
          let that = this;
          let data = {
            channel: that.channel,
            draw_all: 1, // 0挨个点  1全翻
          };
          // 请求后台拿到获取的礼物奖励
          this.$jsonp(this.$apis("xy_DrawGift"), data, (res) => {
            if (res.data.data.list.length != 0) {
              let giftArr = res.data.data.list; //抽奖对应的奖品返回
              for (let i = 0; i < that.canNum; i++) {
                newArr[i].classList.add("aniSele");
                newArr[i].children[2].children[1].children[0].children[0].src =
                  giftArr[i].gift_image;
                newArr[i].children[2].children[1].children[1].innerText =
                  giftArr[i].gift_name;
              }
              that.allNum = 0;
            }
          });
        }
      } else if (this.allNum < 9 && this.clickNum == 0) {
        // 随机取 canNum个
        let nEle = Array.prototype.slice.call(ele, 0);
        var newEle2 = []; // s随机取出来的数组
        while (nEle.length - (9 - this.canNum)) {
          var index = parseInt(Math.random() * nEle.length);
          newEle2 = newEle2.concat(nEle.splice(index, 1));
        }
        console.log(newEle2);
        let _this = this;
        let data = {
          channel: _this.channel,
          draw_all: 1, // 0挨个点  1全翻
        };
        // 请求后台拿到获取的礼物奖励
        this.$jsonp(this.$apis("xy_DrawGift"), data, (res) => {
          if (res.data.data.list.length != 0) {
            let giftArr2 = res.data.data.list; //抽奖对应的奖品返回
            console.log(giftArr2);
            for (let i = 0; i < newEle2.length; i++) {
              newEle2[i].classList.add("aniSele");
              newEle2[i].children[2].children[1].children[0].children[0].src =
                giftArr2[i].gift_image;
              newEle2[i].children[2].children[2].innerText =
                giftArr2[i].gift_name;
            }
            _this.allNum -= _this.canNum;
          }
        });
      }
      this.isCanFan = false; // false后 按钮不可点击
    },

    // 获取抽奖总次数
    getAllNum() {
      let _this = this,
        data = {
          ident: 2,
        };
      this.$jsonp(this.$apis("xy_cjnum"), data, (res) => {
        _this.allNum = parseInt(res.data.data.num);
        _this.getAllGiftlist(); //获取所有的礼物列表
      });
    },

    // 获取所有的礼物列表
    getAllGiftlist() {
      let _this = this;
      this.$jsonp(this.$apis("xy_getDrawGiftlist"), {}, (res) => {
        _this.giftList = res.data.data;
        if (res.data.data.length > 0) {
          setTimeout(() => {
            _this.getHeight();
          }, 300);
        }
      });
    },

    // 设置顶部的内置padding
    setTopPad() {
      let topNavHt = document.querySelector(".top_nav").offsetHeight;
      document.querySelector(".setPad").style.paddingTop = topNavHt + 10 + "px";
    },
  },
};
</script>










<style scoped>
#xy_fp {
  min-height: 100vh;
  background: url("../../assets/xyuan/xy(2).png") left top no-repeat,
    url("../../assets/xyuan/xy.png") left bottom no-repeat,
    linear-gradient(to bottom, #310261, #d0363f);
  background-size: 100%, 100%;
}
.allA {
  z-index: 0;
  background-color: rgba(0, 0, 0, 0.7);
}
.main {
  width: 100%;
  background-size: 100%, 100%;
  padding: 15px 25px 0;
  z-index: 1;
}
/* 9个牌的盒子开始 */
.gift_con {
  width: 63px;
  height: 63px;
  top: 15%;
}
.g_img {
  width: 100%;
}
.g_name {
  bottom: 14%;
  width: 85%;
  display: flex;
  justify-content: center;
  text-align: center;
  height: 30px;
  margin: 6px auto;
  margin-top: 6px;
  padding: 1px 2px 2px;
  font-size: 0.5625rem;
  color: #d36100;
}
.pai_box {
  width: 100%;
}
.pai_box .lis {
  width: 31%;
  margin-top: 8px;
  transform-style: preserve-3d;
  transform-origin: center;
}
.pai_box .lis:nth-child(1) {
  top: 0;
  left: 0;
}
.pai_box .lis:nth-child(2) {
  top: 0;
  left: 34.5%;
}
.pai_box .lis:nth-child(3) {
  top: 0;
  left: 69%;
}
.pai_box .lis:nth-child(4) {
  top: 32%;
  left: 0;
}
.pai_box .lis:nth-child(5) {
  top: 32%;
  left: 34.5%;
  z-index: 5;
}
.pai_box .lis:nth-child(6) {
  top: 32%;
  left: 69%;
}
.pai_box .lis:nth-child(7) {
  top: 64%;
  left: 0;
}
.pai_box .lis:nth-child(8) {
  top: 64%;
  left: 34.5%;
}
.pai_box .lis:nth-child(9) {
  top: 64%;
  left: 69%;
}
.main .anima_box li {
  transition: all 0.5s ease-in-out;
}
.main .ctr_box li {
  top: 32% !important;
  left: 34.5% !important;
}
.opcityNone {
  opacity: 0;
}
.front_div,
.back_div {
  top: 0;
  left: 0;
  backface-visibility: hidden;
}
.front_div {
  transform: rotateY(-180deg);
}
.back_div {
  width: 100%;
  z-index: -1;
}
/* 翻牌过来的类名动效 */
.aniDiv {
  animation: turnBack 0.5s linear forwards;
}
.aniSele {
  animation: aniSele 0.5s linear forwards;
}
/* 所有牌翻到奖品面朝下 */
@keyframes turnBack {
  0% {
    transform: rotateY(0);
  }
  100% {
    transform: rotateY(180deg);
  }
}
@-webkit-keyframes turnBack {
  0% {
    transform: rotateY(0);
  }
  100% {
    transform: rotateY(180deg);
  }
}
/* 点击每一个牌奖品面朝上*/
@keyframes aniSele {
  0% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(0);
  }
}
@-webkit-keyframes aniSele {
  0% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(0);
  }
}
/* 9个牌的盒子结束 */

/* 底部按钮中奖记录盒子 */
.botm_box {
  width: 100%;
}
.cord_con {
  color: #fff;
  text-align: center;
  margin: auto;
  font-size: 15px;
}
.cord_con i {
  font-style: normal;
  padding-bottom: 3px;
  border-bottom: 1px solid #fff;
}
.botm_div {
  width: 90%;
  margin: auto;
  margin-top: 20px;
}
i {
  font-style: normal;
}
.ab_con {
  top: 30%;
  align-items: center;
  color: #fff;
  font-size: 0.9375rem;
}
.ab_con i:nth-child(2) {
  font-weight: bold;
  font-size: 1.25rem;
}

/* 记录弹窗 */
.tc_high {
  z-index: 18;
  transform: translateZ(100px);
}
.tc_main {
  width: 88%;
  z-index: 19;
}
.cord_jl {
  width: 100%;
}
.gift_main {
  top: 17%;
  width: 100%;
  height: 66%;
  overflow-y: scroll;
}
.gift_box {
  margin: auto;
  width: 62%;
}
.close_div {
  width: 10%;
  top: -3%;
  right: 0;
  z-index: 3;
}
.close_div img {
  width: 100%;
}
.cor_lis {
  width: 100%;
  margin-top: 13px;
}
.gimg_box {
  width: 55px;
  height: 55px;
  background-color: #740db6;
  border: 1px solid #600899;
  border-radius: 10px;
}
.gimg_box img {
  width: 80%;
}
.r_box {
  width: calc(100% - 75px);
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  margin-left: 20px;
}
.r_box p {
  height: 45%;
  display: flex;
  align-items: center;
}
.r_box p:nth-child(1) {
  font-weight: bold;
}
/* 扣除抽奖次数的弹窗 */
.kou_box {
  width: 90%;
}
.kou_main {
  width: 70%;
  top: 30%;
  text-align: center;
}
.b_main {
  width: 100%;
  margin-top: 32px;
  justify-content: space-around;
}
.b_main div {
  width: 31%;
}
.text_con {
  font-size: 0.8125rem;
  color: #fff;
}
.text_con i {
  color: #f384e5;
  font-size: 18px;
  font-weight: bold;
}

/* 中奖记录为空的样式 */
.kongbox img {
  width: 80%;
  margin: auto;
}
.text_no {
  width: 100%;
  color: #fff;
  font-size: 13px;
  text-align: center;
}

.nomore {
  color: #fff;
  font-size: 12px;
  width: 100%;
  text-align: center;
  margin-top: 12px;
}
</style> 
